const defaultImg='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABHNCSVQICAgIfAhkiAAAAA1JREFUCFtj+PTp038ACYYD1nRHWUsAAAAASUVORK5CYII='
export const lazyConfig = {
    preLoad: 1.3,
    attempt: 3,
    error: defaultImg, //错误时展示的图片，base64或http
    loading: defaultImg //懒加载loading图
}
